
export class PropertyDefinitionIdConverter {
    private constructor() {}

    static convertToPropDefId(attrDefId: string): string {
        return "id-" + attrDefId;
    }

    static convertToAttrDefId(propDefId: string): string {
        if (propDefId.startsWith("id-")) {
            return propDefId.substring("id-".length);
        } else {
            return propDefId;
        }
    }
}